import React from "react";
import { createPortal } from "react-dom";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Text } from "../../../themes/userq/Text/Text";
import { Button } from "../../../themes/userq/Button/Button";

const AI_LOADER_SRC = `${process.env.REACT_APP_URL}img/AILoader.gif`;

export const AIFeatureBanner = ({ onGenerateSummary, loading }) => {
    return (
        <>
            <div className="ai-feature-banner">
                <div className="ai-feature-banner-content">
                    <Icon
                        value="Ai"
                        size="large"
                        colorClass="ai-feature-banner-icon-svg"
                    />
                    <Text type="subtitle-2" cssClasses="ai-feature-banner-text">
                            Summarize responses with AI
                    </Text>
                </div>
                <Button
                    type="secondary"
                    size="medium"
                    label={loading ? "Generating..." : "Generate summary"}
                    cssclass="ai-generate-summary-btn"
                    state={loading ? "disabled" : "active"}
                    onClick={onGenerateSummary || (() => {
                        console.log('Generate summary clicked');
                    })}
                />
            </div>
            {loading &&
                createPortal(
                    <div
                        className="ai-full-page-loader-overlay"
                        role="status"
                        aria-live="polite"
                        aria-busy="true"
                        aria-label="Generating AI summary"
                    >
                        <div className="ai-full-page-loader-panel">
                            <img
                                className="ai-full-page-loader-gif"
                                src={AI_LOADER_SRC}
                                alt=""
                            />
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
};
